import { useEffect } from 'libs/react';
import { useState } from 'libs/react';
import { useWatch } from 'libs/react';
import { useForm } from '../Form';
/**
 * @component useGroup
 * @since 1.0.0
 */
export function useGroup(name, prop, init) {
    const form = useForm();
    const [value, setValue] = useState(prop == null ? init : prop);
    useEffect(() => {
        return () => {
            if (form.hasValue(name) && form.getValue(name) == value) {
                form.removeValue(name);
            }
        };
    }, []);
    useWatch(() => {
        if (form.hasValue(name) && form.getValue(name) == value) {
            form.updateValue(name, prop);
        }
        setValue(value);
    }, [prop]);
    return [
        function (value) {
            form.updateValue(name, value);
        }
    ];
}
